export default {
  computed: {
    activeRoute() {
      
      // Home page
      if (this.item.path === "/" && document.location.pathname === "/") {
        return true;
      }

      const href = document.location.pathname.replace("/app/", "");

      return this.item.path !== "/" && this.item.path === href;

    },
  }
}